module.exports = __webpack_public_path__ + "static/media/notaItem.3d8188fd.jpg";